import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{page-title \"Solomon Reporting\"}}\n\n{{outlet}}",{ moduleName: "solomon-next-reporting-ui/templates/application.hbs" })